import { useEffect, useState } from 'react';
import { useSoundStore } from 'utils/sound-store';

export const useWindowFocus = () => {
  const volume = useSoundStore(state => state.volume);
  const setVolume = useSoundStore(state => state.setVolume);
  const [currentVolume, setCurrentVolume] = useState(volume);

  useEffect(() => {
    function checkFocus() {
      if (currentVolume > 0) {
        setVolume(currentVolume);
      }
    }

    function checkBlur() {
      setCurrentVolume(volume);
      if (volume > 0) {
        setVolume(0);
      }
    }

    window.addEventListener('focus', checkFocus);
    window.addEventListener('blur', checkBlur);

    return () => {
      window.removeEventListener('focus', checkFocus);
      window.removeEventListener('blur', checkBlur);
    }
  }, [currentVolume, setVolume, volume]);
}
